<template>
  <header
    v-if="verifyStatusCadastro"
    class="sticky top-0 z-50 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 shadow-sm"
  >
    <div class="flex items-center justify-between px-6 py-4">
      <!-- Logo -->
      <div class="h-8">
        <img
          v-if="
            nomeEmpresa == 'BRITECH' ||
            nomeEmpresa == 'DNWAYS_DEMO_Y' ||
            nomeEmpresa == 'DNWAYS_DEMO_X' ||
            nomeEmpresa == 'DNWAYS'
          "
          src="@/assets/logoHeader.png"
          class="h-12 w-auto dark:brightness-200"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'Vortex'"
          src="@/assets/dnways.png"
          class="h-12 w-auto dark:brightness-200"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'ACTUAL'"
          src="@/assets/logoActual_v2.png"
          class="h-12 w-auto dark:logo-invert-dark"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'GENIAL'"
          src="@/assets/logogenial.png"
          class="h-12 w-auto dark:brightness-200"
          :style="{ filter: !isDark ? 'none' : 'invert(1)' }"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'RJI'"
          src="@/assets/logo/rji.png"
          class="h-12 w-auto dark:brightness-200"
          :style="{ filter: !isDark ? 'invert(1)' : 'none' }"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'Lastro'"
          src="@/assets/logoLastro.jpg"
          class="h-12 w-auto dark:brightness-200"
          :alt="nomeEmpresa"
        />

        <img
          v-else-if="nomeEmpresa == 'OSLO'"
          src="@/assets/logo/oslo.svg"
          class="h-8 w-auto dark:brightness-200"
          :style="{ filter: !isDark ? 'none' : 'brightness(0) invert(1)' }"
          :alt="nomeEmpresa"
        />
      </div>

      <!-- Navigation buttons -->
      <div class="flex items-center gap-3">
        <!-- Dark mode toggle -->
        <button
          @click="toggleTheme"
          class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
          aria-label="Toggle dark mode"
        >
          <svg
            v-if="!isDark"
            class="w-5 h-5 text-yellow-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
              fill-rule="evenodd"
              clip-rule="evenodd"
            ></path>
          </svg>
          <svg
            v-else
            class="w-5 h-5 text-blue-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
            ></path>
          </svg>
        </button>

        <!-- Alterar senha -->
        <button
          v-if="configuracaoToken != 'S'"
          @click="alterarSenha()"
          class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          Alterar senha
        </button>

        <!-- Logoff -->
        <button
          @click="logoff"
          class="px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
        >
          Logoff
        </button>
      </div>
    </div>
  </header>
  <div
    v-if="verifyStatusCadastro"
    class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6"
  >
    <div class="mb-8">
      <div class="flex items-center gap-4 mb-3">
        <div
          class="flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-primary to-blue-600 dark:from-blue-600 dark:to-blue-500 shadow-lg"
        >
          <svg
            class="w-7 h-7 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
        </div>
        <div>
          <h2
            class="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 dark:from-gray-100 dark:to-gray-300 bg-clip-text text-transparent"
          >
            Olá, {{ user?.NomeRazaoSocial }}!
          </h2>
          <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Bem-vindo(a) ao seu cadastro na {{ this.nomeEmpresa }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="!inicializado"
      class="flex justify-center items-center min-h-[200px]"
    >
      <div class="loading-overlay">
        <div class="spinner"></div>
      </div>
    </div>
    <div v-if="inicializado" class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
      <div
        :class="[
          'border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 p-6',
          user?.StatusCadastro == 2 && habilitaRenovacao
            ? 'lg:col-span-1'
            : 'lg:col-span-1',
        ]"
      >
        <div v-if="user?.StatusCadastro == 1" class="flex items-center mb-4">
          <div
            class="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-100 dark:bg-yellow-900/30 mr-3"
          >
            <i
              class="fa fa-clock text-yellow-600 dark:text-yellow-400 text-xl"
            ></i>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-semibold text-gray-900 dark:text-gray-100"
              >Cadastro em aprovação</span
            >
            <span class="text-sm text-gray-600 dark:text-gray-400"
              >Seu cadastro está em processo de aprovação</span
            >
          </div>
        </div>
        <div
          v-if="user?.StatusCadastro == 2 && habilitaRenovacao"
          class="flex items-center mb-4"
        >
          <div
            class="flex items-center justify-center w-10 h-10 rounded-full bg-orange-100 dark:bg-orange-900/30 mr-3"
          >
            <i
              class="fa fa-exclamation-triangle text-orange-600 dark:text-orange-400 text-xl"
            ></i>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-semibold text-gray-900 dark:text-gray-100"
              >Atualização cadastral pendente</span
            >
            <span class="text-sm text-gray-600 dark:text-gray-400"
              >Garanta que suas informações estejam atualizadas para garantir o
              acesso aos nosso serviços</span
            >
          </div>
        </div>
        <div
          v-if="user?.StatusCadastro == 2 && !habilitaRenovacao"
          class="flex items-center mb-4"
        >
          <div
            class="flex items-center justify-center w-10 h-10 rounded-full bg-green-100 dark:bg-green-900/30 mr-3"
          >
            <i
              class="fa fa-check-circle text-green-600 dark:text-green-400 text-xl"
            ></i>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-semibold text-gray-900 dark:text-gray-100"
              >Cadastro aprovado</span
            >
            <span class="text-sm text-gray-600 dark:text-gray-400"
              >Seu cadastro foi aprovado!</span
            >
          </div>
        </div>
        <div v-if="user?.StatusCadastro == 3" class="flex items-center mb-4">
          <div
            class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 mr-3"
          >
            <i
              class="fa fa-times-circle text-red-600 dark:text-red-400 text-xl"
            ></i>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-semibold text-gray-900 dark:text-gray-100"
              >Cadastro vencido</span
            >
            <span class="text-sm text-gray-600 dark:text-gray-400"
              >Seu cadastro está vencido</span
            >
          </div>
        </div>
        <div v-if="user?.StatusCadastro == 4" class="flex items-center mb-4">
          <div
            class="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 mr-3"
          >
            <i
              class="fa fa-search text-blue-600 dark:text-blue-400 text-xl"
            ></i>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-semibold text-gray-900 dark:text-gray-100"
              >Cadastro em revisão</span
            >
            <span class="text-sm text-gray-600 dark:text-gray-400"
              >Seu cadastro está em revisão</span
            >
          </div>
        </div>
        <div v-if="user?.StatusCadastro == 5" class="flex items-center mb-4">
          <div
            class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-900/30 mr-3"
          >
            <i class="fa fa-ban text-gray-600 dark:text-gray-400 text-xl"></i>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-semibold text-gray-900 dark:text-gray-100"
              >Cadastro inativo</span
            >
            <span class="text-sm text-gray-600 dark:text-gray-400"
              >Seu cadastro está inativo</span
            >
          </div>
        </div>
        <div class="flex flex-col sm:flex-row gap-2 mt-4">
          <button
            class="btn-secondary text-sm px-4 py-2"
            @click="downloadFicha()"
          >
            Download cadastro
          </button>
          <button
            v-if="possuiMockPosicaoPas"
            class="btn-secondary text-sm px-4 py-2"
            @click="visualizarPosicao()"
          >
            Visualizar posição
          </button>
        </div>
      </div>
      <div
        v-if="user?.TipoCliente != TIPO_CLIENTE.FUNDOS"
        :class="[
          'border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 p-6',
          habilitarModalCadastroAlterado ? 'lg:col-span-1' : 'lg:col-span-2',
        ]"
      >
        <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Perfil investidor:
          {{
            perfilSuitabilityPreview
              ? perfilSuitabilityPreview.Perfil
              : dadosUsuario.PerfilRisco
          }}
        </h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
          Esse é o resultado do seu perfil. Caso queira, você poderá refazê-lo.
        </p>
        <div class="flex flex-col sm:flex-row gap-2">
          <button
            v-if="!temDispensaQuestionario"
            :class="[
              'px-6 py-2.5 text-sm font-medium rounded-lg transition-colors shadow-sm',
              habilitaRenovacao && !verificaSeJaConcluiuEtapa(9)
                ? 'text-white bg-orange-600 hover:bg-orange-700 border-orange-600'
                : 'text-white bg-primary dark:bg-blue-600 hover:bg-primary-dark dark:hover:bg-blue-700',
            ]"
            @click="abrirQuestionario()"
          >
            {{ labelAbrirQuestionario }}
          </button>
          <button class="btn-secondary" @click="abrirSaibaMais()">
            Saiba mais
          </button>
        </div>
      </div>
      <div
        v-if="habilitarModalCadastroAlterado"
        class="border border-primary dark:border-blue-900 rounded-lg bg-primary dark:bg-blue-900 text-white p-6 lg:col-span-1"
      >
        <h3 class="text-lg font-semibold mb-2">Cadastro Alterado</h3>
        <p class="text-sm mb-4 opacity-90">
          Você efetuou as alterações em seu cadastro, mas elas ainda não foram
          enviadas. Ao clicar em "Enviar cadastro atualizado", todas as
          informações salvas serão enviadas para análise e registro.
        </p>
        <button
          :class="[
            'px-6 py-2.5 text-sm font-medium rounded-lg transition-colors shadow-sm w-full',
            habilitaRenovacao && !verificaSeJaConcluiuEtapa(9)
              ? 'bg-orange-600 hover:bg-orange-700 text-white border-orange-600'
              : 'bg-yellow-400 hover:bg-yellow-500 text-primary border-yellow-400',
          ]"
          @click="enviarCadastro()"
        >
          Enviar cadastro atualizado
        </button>
      </div>
    </div>
    <div v-if="user?.TipoCliente == TIPO_CLIENTE.PESSOA_FISICA" class="mt-8">
      <div class="flex items-center gap-4 mb-8">
        <div v-if="editar && numEtapa != 9">
          <button type="button" class="btn-secondary" @click="sairEdicao()">
            Voltar
          </button>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Cadastro
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Se necessário, revise seus dados cadastrados abaixo
          </p>
        </div>
      </div>
      <div v-if="!editar || numEtapa == 9">
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img src="@/assets/user.png" alt="Dados Cadastrais" />
              <span class="title">Dados Cadastrais</span>
            </div>
            <span class="desc">Informações pessoais do seu cadastro.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(0),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(0),
                  }"
                  @click="abrirEditor(0)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(0) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_procuradores.svg" alt="Procuradores" />
              <span class="title">Procuradores</span>
            </div>
            <span class="desc">Informações dos procuradores</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(1),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(1),
                  }"
                  @click="abrirEditor(1)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(1) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img
                src="@/assets/_dados financeiros.svg"
                alt="Dados Financeiros"
              />
              <span class="title">Dados Financeiros</span>
            </div>
            <span class="desc">Situação financeira e patrimonial</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(2),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(2),
                  }"
                  @click="abrirEditor(2)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(2) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="agrupamento-quadros">
          <div
            class="quadro-configuracao quadro-configuracao-primeiro"
            v-if="nomeEmpresa != 'GENIAL'"
          >
            <div class="configuracao-header">
              <img src="@/assets/_dados bancarios.svg" alt="Dados Bancários" />
              <span class="title">Dados Bancários</span>
            </div>
            <span class="desc">Suas contas bancarias</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(3),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(3),
                  }"
                  @click="abrirEditor(3)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(3) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_endereco.svg" alt="Endereço" />
              <span class="title">Endereço</span>
            </div>
            <span class="desc">Informações pessoais do seu cadastro.</span>

            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(4),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(4),
                  }"
                  @click="abrirEditor(4)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(4) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_documentos.svg" alt="Documentos" />
              <span class="title">Documentos</span>
            </div>
            <span class="desc">Arquivos anexados</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(5),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(5),
                  }"
                  @click="abrirEditor(5)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(5) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img src="@/assets/_declaracoes.svg" alt="Declarações" />
              <span class="title">Declarações</span>
            </div>
            <span class="desc">Termos aceitos</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(6),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(6),
                  }"
                  @click="abrirEditor(6)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(6) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_produtos.svg" alt="Produtos" />
              <span class="title">Produtos</span>
            </div>
            <span class="desc"
              >Produtos com base no seu perfil investidor.</span
            >
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(7),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(7),
                  }"
                  @click="abrirEditor(7)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(7) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="editar && numEtapa != 9">
        <CadastroPF
          v-model:Edicao="editar"
          :BloquearSalvarIsolado="habilitaRenovacao"
        />
      </div>
    </div>
    <div v-if="user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA" class="mt-8">
      <div class="flex items-center gap-4 mb-8">
        <div v-if="editar && numEtapa != 9">
          <button type="button" class="btn-secondary" @click="sairEdicao()">
            Voltar
          </button>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Cadastro
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Se necessário, revise seus dados cadastrados abaixo
          </p>
        </div>
      </div>
      <div v-if="!editar || numEtapa == 9">
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img
                src="@/assets/_dados da empresa.svg"
                alt=":this.User.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA ? 'Dados da Empresa' : 'Dados Institucional'"
              />
              <span class="title">
                {{
                  user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA
                    ? "Dados da Empresa"
                    : "Dados Institucional"
                }}
              </span>
            </div>
            <span class="desc">Informações do seu cadastro.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(0),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(0),
                  }"
                  @click="abrirEditor(0)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(0) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_procuradores.svg" alt="Procuradores" />
              <span class="title">Procuradores</span>
            </div>
            <span class="desc">Informações dos procuradores da empresa.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(1),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(1),
                  }"
                  @click="abrirEditor(1)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(1) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_representantes.svg" alt="Representantes" />
              <span class="title">Representantes</span>
            </div>
            <span class="desc">Informações dos representantes da empresa.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(2),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(2),
                  }"
                  @click="abrirEditor(2)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(2) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img
                src="@/assets/_dados financeiros.svg"
                alt="Dados Financeiros"
              />
              <span class="title">Dados Financeiros</span>
            </div>
            <span class="desc">Situação financeira e patrimonial</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(3),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(3),
                  }"
                  @click="abrirEditor(3)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(3) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao" v-if="nomeEmpresa != 'GENIAL'">
            <div class="configuracao-header">
              <img src="@/assets/_dados bancarios.svg" alt="Dados Bancários" />
              <span class="title">Dados Bancários</span>
            </div>
            <span class="desc">Suas contas bancarias</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(4),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(4),
                  }"
                  @click="abrirEditor(4)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(4) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_endereco.svg" alt="Endereço" />
              <span class="title">Endereço</span>
            </div>
            <span class="desc">Informações pessoais do seu cadastro.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(5),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(5),
                  }"
                  @click="abrirEditor(5)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(5) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img src="@/assets/_documentos.svg" alt="Documentos" />
              <span class="title">Documentos</span>
            </div>
            <span class="desc">Arquivos anexados</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(6),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(6),
                  }"
                  @click="abrirEditor(6)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(6) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_declaracoes.svg" alt="Declarações" />
              <span class="title">Declarações</span>
            </div>
            <span class="desc">Termos aceitos</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(7),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(7),
                  }"
                  @click="abrirEditor(7)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(7) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_produtos.svg" alt="Produtos" />
              <span class="title">Produtos</span>
            </div>
            <span class="desc"
              >Produtos com base no seu perfil investidor.</span
            >
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(8),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(8),
                  }"
                  @click="abrirEditor(8)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(8) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="editar && numEtapa != 9">
        <CadastroPJ
          v-model:Edicao="editar"
          :BloquearSalvarIsolado="habilitaRenovacao"
        />
      </div>
    </div>
    <div v-if="user?.TipoCliente == TIPO_CLIENTE.FUNDOS" class="mt-8">
      <div class="flex items-center gap-4 mb-8">
        <div v-if="editar && numEtapa != 9">
          <button type="button" class="btn-secondary" @click="sairEdicao()">
            Voltar
          </button>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Cadastro
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Se necessário, revise seus dados cadastrados abaixo
          </p>
        </div>
      </div>
      <div v-if="!editar || numEtapa == 9">
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img src="@/assets/user.png" alt="Dados Cadastrais" />
              <span class="title">Dados Cadastrais</span>
            </div>
            <span class="desc">Informações seu cadastro.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(0),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(0),
                  }"
                  @click="abrirEditor(0)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(0) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_procuradores.svg" alt="Procuradores" />
              <span class="title">Procuradores</span>
            </div>
            <span class="desc">Informações dos procuradores da empresa.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(1),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(1),
                  }"
                  @click="abrirEditor(1)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(1) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_representantes.svg" alt="Participantes" />
              <span class="title">Participantes</span>
            </div>
            <span class="desc">Informações dos participantes da empresa.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(2),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(2),
                  }"
                  @click="abrirEditor(2)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(2) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img
                src="@/assets/_dados financeiros.svg"
                alt="Dados Financeiros"
              />
              <span class="title">Dados Financeiros</span>
            </div>
            <span class="desc">Situação financeira e patrimonial</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(3),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(3),
                  }"
                  @click="abrirEditor(3)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(3) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao" v-if="nomeEmpresa != 'GENIAL'">
            <div class="configuracao-header">
              <img src="@/assets/_dados bancarios.svg" alt="Dados Bancários" />
              <span class="title">Dados Bancários</span>
            </div>
            <span class="desc">Suas contas bancarias</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(4),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(4),
                  }"
                  @click="abrirEditor(4)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(4) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_documentos.svg" alt="Documentos" />
              <span class="title">Documentos</span>
            </div>
            <span class="desc">Arquivos anexados</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(5),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(5),
                  }"
                  @click="abrirEditor(5)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(5) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="agrupamento-quadros">
          <div class="quadro-configuracao quadro-configuracao-primeiro">
            <div class="configuracao-header">
              <img src="@/assets/_declaracoes.svg" alt="Declarações" />
              <span class="title">Declarações</span>
            </div>
            <span class="desc">Informações diversas</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(6),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(6),
                  }"
                  @click="abrirEditor(6)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(6) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_fatca.svg" alt="FATCA" />
              <span class="title">FATCA</span>
            </div>
            <span class="desc">Foreign Account Tax Compliance Act.</span>
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(7),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(7),
                  }"
                  @click="abrirEditor(7)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(7) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="quadro-configuracao">
            <div class="configuracao-header">
              <img src="@/assets/_produtos.svg" alt="Produtos" />
              <span class="title">Produtos</span>
            </div>
            <span class="desc"
              >Produtos com base no seu perfil investidor.</span
            >
            <div class="footer">
              <div class="buttonsAcoes">
                <button
                  class="btnDefault"
                  :class="{
                    btnLaranja:
                      habilitaRenovacao && !verificaSeJaConcluiuEtapa(8),
                    btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(8),
                  }"
                  @click="abrirEditor(8)"
                >
                  {{
                    verificaSeJaConcluiuEtapa(8) && habilitaRenovacao
                      ? "Dados Atualizados"
                      : labelAbrirForm
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="editar && numEtapa != 9">
        <CadastroFI
          v-model:Edicao="editar"
          :BloquearSalvarIsolado="habilitaRenovacao"
        />
      </div>
    </div>
    <ModalQuestionario />
    <ModalInformativoSaibaMais />
    <ModalAlterarSenha />
    <ModalCadastroVencido :isFundos="user?.TipoCliente == TIPO_CLIENTE.FUNDOS" />

    <ModalAviso
      :id="'ModalRenovacao'"
      :titulo="'Atenção: Seu cadastro está próximo do vencimento!'"
      :labelOpcoes="'Deseja realizar a atualização agora?'"
      :botoes="[
        { texto: 'Sim, atualizar agora', acao: renovarCadastro },
        { texto: 'Lembrar depois', emit: 'fechar' },
      ]"
    />

    <ModalVisualizarPosicao />

    <ModalAviso
      :id="'ModalConfirmar'"
      :titulo="'Atenção: Confirme o envio das alterações!'"
      :labelOpcoes="'Ao clicar em Enviar cadastro atualizado, todas as informações salvas serão enviadas para análise e registro. '"
      :botoes="[
        { texto: 'Enviar cadastro atualizado', acao: enviarCadastro },
        {
          texto: 'Ainda não terminei de atualizar',
          acao: abrirDivCadastroAlterado,
        },
      ]"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@/api/axios";
import { useTheme } from "@/composables/useTheme";
import CadastroPF from "./Cadastro/PF/CadastroPF_Passo_1.vue";
import CadastroPJ from "./Cadastro/PJ/CadastroPJ_Passo_1.vue";
import CadastroFI from "./Cadastro/FI/CadastroFI_Passo_1.vue";
import ModalCadastroVencido from "@/views/Login/ModalCadastroVencido.vue";
import ModalQuestionario from "@/views/Cadastro/Questionario/ModalQuestionario.vue";
import ModalInformativoSaibaMais from "@/views/Cadastro/SaibaMais/ModalInformativoSaibaMais.vue";
import ModalAlterarSenha from "./Cadastro/AlterarSenha/ModalAlterarSenha.vue";
import ModalAviso from "./Cadastro/Utilitarios/ModalAviso.vue";
import ModalVisualizarPosicao from "./Dashboard/ModalVisualizarPosicao.vue";
import navigationTracker from "@/services/modules/userNavigationTracker";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";

export default {
  name: "DashboardInicio",
  components: {
    CadastroPF,
    ModalQuestionario,
    CadastroPJ,
    CadastroFI,
    ModalInformativoSaibaMais,
    ModalAlterarSenha,
    ModalCadastroVencido,
    ModalAviso,
    ModalVisualizarPosicao,
  },
  setup() {
    const { isDark, toggleTheme } = useTheme();
    return { isDark, toggleTheme };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      perfilCliente: "GET_PERFIL_CLIENTE",
      getConfiguracoes: "GET_CONFIGURACOES",
      etapasConcluidas: "GET_ETAPA_CONCLUIDA",
      getConcluir: "GET_FICHA_CONCLUIR",
      perfilSuitabilityPreview: "GET_SUITABILITY_PREVIEW",
      getModalQuestionario: "GET_MODAL_QUESTIONARIO",
      infoDispensaQuestionario: "GET_PF_PJ_INFO_DISPENSA_QUESTIONARIO",
      dispensaQuestionarioRemovida: "GET_DISPENSA_QUESTIONARIO_REMOVIDA",
    }),
    temDispensaQuestionario() {
      return this.infoDispensaQuestionario?.MotivoDispensaQuestionarioId > 0;
    },
    labelAbrirForm() {
      return this.habilitaRenovacao ? "Atualizar dados" : "Editar dados";
    },
    labelAbrirQuestionario() {
      return this.habilitaRenovacao
        ? "Atualizar questionário"
        : "Refazer questionário";
    },
    possuiMockPosicaoPas() {
      return process.env.VUE_APP_POSSUI_MOCK_POSICAO_PAS == 1 ? true : false;
    },
    edicaoConcluida() {
      if (this.user == null) {
        return false;
      }

      if (this.user.TipoCliente == TIPO_CLIENTE.PESSOA_FISICA) {
        const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 9];

        if (this.nomeEmpresa && this.nomeEmpresa.toUpperCase() != "GENIAL") {
          etapasObrigatorias.push(4);
        }

        const etapasConcluidas = Array.isArray(this.etapasConcluidas)
          ? this.etapasConcluidas.filter((e) => typeof e === "number")
          : [];

        var concluidoPF =
          Array.isArray(etapasConcluidas) &&
          etapasObrigatorias.every((etapa) => etapasConcluidas.includes(etapa));

        if (concluidoPF) {
          this.$store.commit("SET_MODAL_AVISO", "ModalConfirmar");
        }

        return concluidoPF;
      } else if (this.user.TipoCliente.toUpperCase() != TIPO_CLIENTE.FUNDOS.toUpperCase()) {
        const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8, 9];

        if (this.nomeEmpresa && this.nomeEmpresa.toUpperCase() != "GENIAL") {
          etapasObrigatorias.push(4);
        }

        const etapasConcluidasPJ = Array.isArray(this.etapasConcluidas)
          ? this.etapasConcluidas.filter((e) => typeof e === "number")
          : [];

        var concluido =
          Array.isArray(etapasConcluidasPJ) &&
          etapasObrigatorias.every((etapa) =>
            etapasConcluidasPJ.includes(etapa),
          );

        if (concluido) {
          this.$store.commit("SET_MODAL_AVISO", "ModalConfirmar");
        }

        return concluido;
      } else {
        const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8];

        if (this.nomeEmpresa && this.nomeEmpresa.toUpperCase() != "GENIAL") {
          etapasObrigatorias.push(4);
        }

        const etapasConcluidasFI = Array.isArray(this.etapasConcluidas)
          ? this.etapasConcluidas.filter((e) => typeof e === "number")
          : [];

        concluido =
          Array.isArray(etapasConcluidasFI) &&
          etapasObrigatorias.every((etapa) =>
            etapasConcluidasFI.includes(etapa),
          );

        if (concluido) {
          this.$store.commit("SET_MODAL_AVISO", "ModalConfirmar");
        }
        return concluido;
      }
    },
  },
  data() {
    return {
      TIPO_CLIENTE,
      habilitarModalCadastroAlterado: false,
      enviarCadastroIsolado: false,
      inicializado: false,
      verifyStatusCadastro: false,
      nomeEmpresa: "",
      habilitaRenovacao: false,
      dadosUsuario: {
        PerfilRisco: "",
      },
      loginSession: {
        Usuario: null,
        Senha: null,
      },
      enviarCadastroRenovacao: false,
      editar: false,
      numEtapa: 0,
      messageError: null,
      erro: false,
      configuracaoToken: "n",
    };
  },
  watch: {
    getModalQuestionario() {
      if (this.getModalQuestionario) {
        this.abrirEditor(9);
      }
    },
    edicaoConcluida(novoValor) {
      if (novoValor) {
        this.habilitarModalCadastroAlterado = true;
      }
    },
    getConcluir() {
      if (
        this.getConcluir == false &&
        (this.etapasConcluidas.length > 1 || !this.habilitaRenovacao) &&
        this.inicializado
      ) {
        this.$store.commit("SET_ETAPA_CONCLUIDA", null);
        this.habilitaRenovacao = false;
        this.habilitarModalCadastroAlterado = false;
      }
    },
    perfilCliente() {
      if (this.perfilCliente)
        if (this.perfilCliente[0]) {
          this.dadosUsuario = this.perfilCliente[0];

          if (this.perfilSuitabilityPreview?.Id > 0) {
            this.$store.dispatch(
              "FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW",
              this.perfilSuitabilityPreview?.Id,
            );
          } else {
            this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS");
          }

          this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE");
        }
    },
    perfilSuitabilityPreview() {
      if (this.perfilSuitabilityPreview?.Id > 0) {
        this.$store.dispatch(
          "FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW",
          this.perfilSuitabilityPreview?.Id,
        );

        this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE");
      }
    },
    infoDispensaQuestionario() {
      if (this.temDispensaQuestionario && !this.verificaSeJaConcluiuEtapa(9)) {
        this.$store.commit("SET_ETAPA_CONCLUIDA", 9);
      } else if (
        !this.temDispensaQuestionario &&
        this.verificaSeJaConcluiuEtapa(9) &&
        (!this.dadosUsuario.PerfilRisco || this.dadosUsuario.PerfilRisco === "")
      ) {
        this.$store.commit("REMOVE_ETAPA_CONCLUIDA", 9);
      }
    },
  },
  async mounted() {
    this.$store.commit("SET_ETAPA_CONCLUIDA", null);
    this.$store.commit("SET_ENVIAR_CADASTRO", false);
    this.$store.commit("SET_MODAL_AVISO", false);
    this.$store.commit("SET_MODAL_CADASTRO_VENCIDO", false);

    this.dadosUsuario.nome = localStorage.getItem("nomeRazaoSocial");
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;

    await this.fetchConfiguracao(["Modo de autenticação"]);
    this.configuracaoToken =
      this.getConfiguracoes("Modo de autenticação")?.Valor != "2" ? "N" : "S";

    if (
      this.user.TipoCliente == TIPO_CLIENTE.PESSOA_FISICA &&
      this.user.StatusCadastro == 0
    ) {
      this.$router.push({ name: "CadastroPF_Passo_1" });
    } else if (
      (this.user.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA ||
        this.user.TipoCliente == TIPO_CLIENTE.INSTITUCIONAL) &&
      this.user.StatusCadastro == 0
    ) {
      this.$router.push({ name: "CadastroPJ_Passo_1" });
    } else if (
      this.user.TipoCliente == TIPO_CLIENTE.FUNDOS &&
      this.user.StatusCadastro == 0
    ) {
      this.$router.push({ name: "CadastroFI_Passo_1" });
    } else if (this.user.StatusCadastro == 1) {
      this.$router.push({ name: "Dashboard" });
    }

    this.verifyStatusCadastro = true;

    this.$store.commit("SET_MODAL_QUESTIONARIO", false);
    this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", false);

    this.$store.dispatch("FETCH_VERIFICAR_DISPENSA_QUESTIONARIO");
    this.$store.dispatch("FETCH_DISPENSA_QUESTIONARIO");

    // Inicializar SignalR antes do tracking
    await this.$store.dispatch("INIT_DECLARACAO_SIGNALR");

    if (this.user?.ClienteId) {
      navigationTracker.startTracking(
        this.user.ClienteId,
        this.user.TipoCliente,
        `dashboard_${Date.now()}`,
      );
      navigationTracker.trackViewChange("dashboard");
    }

    api.get(`suitability`).then((retorno) => {
      if (retorno.status == 200) {
        this.dadosUsuario.PerfilRisco = retorno?.data?.data[0]?.PerfilRisco;
        if (retorno?.data?.data[0]) {
          this.user.StatusCadastro = retorno?.data?.data[0]?.StatusCadastro;
          this.$store.commit("auth/SET_USER", this.user);
        }
        this.processarInicio();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    navigationTracker.stopTracking();
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    visualizarPosicao() {
      this.$store.commit("SET_MODAL_VISUALIZAR_POSICAO", true);
    },
    processarInicio() {
      if (this.user?.StatusCadastro == 2) {
        window.addEventListener("beforeunload", this.beforeUnloadHandler);

        api.get(`cliente/ConsultaLembreteVencimento`).then((retorno) => {
          if (retorno.status == 200) {
            if (retorno?.data?.data) {
              this.$store.commit("SET_MODAL_AVISO", "ModalRenovacao");
            } else {
              this.enviarCadastroIsolado = true;
            }
          }
        });
      } else if (this.user?.StatusCadastro == 3) {
        this.habilitaRenovacao = true;
        window.addEventListener("beforeunload", this.beforeUnloadHandler);
        this.$store.commit("SET_MODAL_CADASTRO_VENCIDO", true);
      }
      this.inicializado = true;
    },
    abrirDivCadastroAlterado() {
      this.habilitarModalCadastroAlterado = true;
      this.$store.commit("SET_MODAL_AVISO", false);
    },
    beforeUnloadHandler(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    verificaSeJaConcluiuEtapa(etapa) {
      return (
        Array.isArray(this.etapasConcluidas) &&
        this.etapasConcluidas.includes(etapa)
      );
    },
    renovarCadastro() {
      console.log("=== RENOVAR CADASTRO ===");
      console.log("infoDispensaQuestionario:", this.infoDispensaQuestionario);
      console.log("temDispensaQuestionario:", this.temDispensaQuestionario);

      this.habilitaRenovacao = true;

      if (!this.temDispensaQuestionario) {
        console.log(" NÃO tem dispensa - Abrindo questionário");
        this.abrirQuestionario();
      } else {
        console.log(" TEM dispensa - NÃO abre questionário");
      }
    },
    enviarCadastro() {
      console.log("=== ENVIAR CADASTRO ===");
      console.log(
        "verificaSeJaConcluiuEtapa(9):",
        this.verificaSeJaConcluiuEtapa(9),
      );
      console.log(
        "dispensaQuestionarioRemovida:",
        this.dispensaQuestionarioRemovida,
      );
      console.log("temDispensaQuestionario:", this.temDispensaQuestionario);

      if (
        !this.verificaSeJaConcluiuEtapa(9) &&
        this.dispensaQuestionarioRemovida
      ) {
        console.log(
          "❌ BLOQUEADO - Dispensa foi removida, precisa preencher questionário",
        );
        this.$swal({
          icon: "error",
          title: "Questionário pendente",
          text: "Você removeu a dispensa do questionário. É necessário preencher o questionário de suitability antes de enviar o cadastro atualizado.",
        });
        return;
      }

      console.log("✅ LIBERADO - Pode enviar cadastro");
      this.editar = true;
      this.$store.commit("SET_ENVIAR_CADASTRO", true);
    },
    alterarSenha() {
      this.$store.commit("SET_ABRIR_ALTERAR_SENHA", true);
    },
    async downloadFicha() {
      try {
        const response = await api.get("/Cliente/pdf", {
          responseType: "arraybuffer",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ficha.pdf");
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: `Falha ao gerar ficha de cadastro`,
        });
      }
    },
    sairEdicao() {
      this.editar = false;
      navigationTracker.trackViewChange("dashboard");
    },
    abrirEditor(numEtapa) {
      navigationTracker.trackStepChange(numEtapa, {
        view: "dashboard",
        editing: true,
        renovacao: this.habilitaRenovacao,
        completedSteps: this.etapasConcluidas || [],
      });

      this.numEtapa = numEtapa;
      this.$store.commit("SET_ETAPA_CADASTRO", numEtapa);
      this.editar = true;
    },
    logoff() {
      this.$store.dispatch("auth/logout");
    },
    abrirQuestionario() {
      this.$store.commit("SET_MODAL_QUESTIONARIO", true);
    },
    abrirSaibaMais() {
      this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", true);
    },
  },
};
</script>

<style scoped>
/* Cards de configuração modernizados */
.agrupamento-quadros {
  @apply w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-5;
}

.quadro-configuracao {
  @apply border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 p-6 flex flex-col w-full shadow-sm hover:shadow-md transition-all duration-200;
  min-height: 180px;
}

.quadro-configuracao:hover {
  @apply border-primary dark:border-blue-500 transform scale-[1.01];
}

.configuracao-header {
  @apply flex items-center gap-3 mb-3;
}

.configuracao-header .icon-wrapper {
  @apply flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-slate-700 transition-colors;
}

.quadro-configuracao:hover .icon-wrapper {
  @apply bg-primary/10 dark:bg-blue-900/30;
}

.configuracao-header img {
  @apply h-6 w-6 object-contain;
}

.configuracao-header .title {
  @apply text-lg font-semibold text-gray-900 dark:text-gray-100;
}

.desc {
  @apply text-sm text-gray-600 dark:text-gray-400 mb-auto leading-relaxed;
}

.footer {
  @apply border-t border-gray-200 dark:border-slate-700 pt-4 mt-4;
}

.footer .buttonsAcoes {
  @apply flex justify-end;
}

.btnDefault {
  @apply px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-all duration-200 flex items-center justify-center;
}

.btnDefault:hover {
  @apply shadow-sm transform scale-[1.02];
}

.btnLaranja {
  @apply text-orange-600 dark:text-orange-400 border-orange-300 dark:border-orange-700 bg-gradient-to-br from-orange-50 to-orange-100/50 dark:from-orange-950/20 dark:to-orange-900/30 hover:from-orange-100 hover:to-orange-200/50 dark:hover:from-orange-900/30 dark:hover:to-orange-800/40 !important;
}

.btnVerde {
  @apply text-green-600 dark:text-green-400 border-green-300 dark:border-green-700 bg-gradient-to-br from-green-50 to-green-100/50 dark:from-green-950/20 dark:to-green-900/30 hover:from-green-100 hover:to-green-200/50 dark:hover:from-green-900/30 dark:hover:to-green-800/40 !important;
}
</style>
